import { z } from "zod";

export {
  SYSTEM_CUSTOMER_ID,
  DEFAULT_CUSTOMER_SLUG,
  SUPER_ADMIN_ROLE,
  BELORA_ADMIN_ROLE,
  WELL_KNOWN_IDS,
} from "./constants.ts";
export { Timestamps } from "./timestamps.schema.ts";
export { toCamelCase, stringToUuid } from "./string.utils.ts";
export { PaginationParams, paginatedResponse } from "./pagination.schema.ts";
export type { PaginatedResponse } from "./pagination.schema.ts";
export { SortDir, ListQueryParams } from "./query-params.ts";

/**
 * Standard JSON type schema for Zod.
 * Recursive definition to support nested objects and arrays.
 */
const literalSchema = z.union([z.string(), z.number(), z.boolean(), z.null()]);
type Literal = z.infer<typeof literalSchema>;

export type Json = Literal | { [key: string]: Json } | Json[];

// Use a schema that matches the Json type exactly
export const Json: z.ZodType<Json> = z.lazy(() =>
  z.union([literalSchema, z.array(Json), z.record(z.string(), Json)]),
);
